import { ReactComponent as ChevronLeftIcon } from '../../images/icons/chevron-left.svg'
import { ReactComponent as ChevronRightIcon } from '../../images/icons/chevron-right.svg'

import styles from './PhotographersPagination.module.css'

const MAX_VISIBLE_PAGES = 5

const PhotographersPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  ariaLabel = 'Photographers pagination',
  className = '',
}) => {
  const pageCount = Number(totalPages) || 1
  const visiblePageCount = Math.min(pageCount, MAX_VISIBLE_PAGES)
  const firstPage = Math.min(
    Math.max(currentPage - Math.floor(visiblePageCount / 2), 1),
    Math.max(pageCount - visiblePageCount + 1, 1),
  )
  const pages = Array.from({ length: visiblePageCount }, (_, index) => firstPage + index)

  return (
    <nav className={`${styles.pagination} ${className}`} aria-label={ariaLabel}>
      <button
        type="button"
        className={`${styles.button} ${styles.navigationButton}`}
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <ChevronLeftIcon className={styles.icon} aria-hidden="true" />
        Back
      </button>

      {pages.map((page) => (
        <button
          type="button"
          className={`${styles.button} ${styles.pageButton} ${
            page === currentPage ? styles.activePage : ''
          }`}
          aria-current={page === currentPage ? 'page' : undefined}
          key={page}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        className={`${styles.button} ${styles.navigationButton}`}
        disabled={!totalPages || currentPage >= pageCount}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next
        <ChevronRightIcon className={styles.icon} aria-hidden="true" />
      </button>
    </nav>
  )
}

export default PhotographersPagination
